/** @jsxImportSource react */
import type { SVGProps } from 'react';
const WarningFill = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.763 2.923c-.901.407-1.586 1.634-2.955 4.087l-3.824 6.851c-1.31 2.348-1.966 3.523-1.855 4.484a3 3 0 0 0 1.228 2.09c.785.566 2.13.566 4.819.566h7.647c2.69 0 4.034 0 4.82-.566a3 3 0 0 0 1.227-2.09c.11-.961-.545-2.136-1.855-4.484l-3.824-6.85c-1.37-2.454-2.054-3.68-2.955-4.088a3 3 0 0 0-2.473 0M12 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 8m1 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
  </svg>
);
export default WarningFill;
